<template>
  <div class="detail-page home-apartment container" v-if="currentFlat">
    <ApartmentPopUp :item="currentFlat"/>
    <div class="apartment-description-wrapper">
      <h2 class="apartment-description-title">Опис</h2>
      <div class="apartment-description-text">
        {{ currentFlat.description }}
      </div>
    </div>
    <!--    BackGround    -->
    <div class="detail-top">
      <img alt="" src="../assets/images/detail_page-top.png"/>
    </div>
    <div class="detail-bot">
      <img alt="" src="../assets/images/detail_page-bot.png"/>
    </div>
  </div>
</template>

<script>
import ApartmentPopUp from '../components/common/PopUps/ApartmentPopUp'
import {Api} from '@/services/AxiosService'

export default {
  name: 'flat-detail',
  created() {
    this.fetchFlatByID()
  },
  components: {
    ApartmentPopUp,
  },
  data() {
    return {
      currentFlat: null,
    }
  },
  methods: {
    async fetchFlatByID() {
      try {
        const ID = this.$route.params.id
        const {
          data: {data},
        } = await Api.fetchFlatByID(ID)
        this.currentFlat = data
      } catch (e) {
        console.log('Error')
      }
    },
  },
}
</script>
